<template>
    <portal to="modal">
        <div class="modal-overlay">
            <div class="modal">
                <button @click.prevent.stop="close" class="modal-close-button" title="Close">
                    <close-icon/>
                </button>
                <div class="modal-header">
                    <slot name="header"></slot>
                </div>
                <div class="modal-content">
                    <slot></slot>
                </div>
                <div class="modal-footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </portal>
</template>

<script>
import CloseIcon from 'src/components/icons/Close';

export default {
    components: {
        CloseIcon,
    },
    mounted() {
        this.keyboardListener = e => {
            if (e.keyCode === 27) {
                this.close();
            }
        };

        document.addEventListener('keyup', this.keyboardListener);
    },

    beforeDestroy() {
        document.removeEventListener('keyup', this.keyboardListener);
    },
    methods: {
        close() {
            this.$emit('closed');
        },
    },
};
</script>